import { useState, useCallback, useEffect } from 'react';
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var BazaarVoice = /*#__PURE__*/_createClass(function BazaarVoice() {
  var _this = this;
  _classCallCheck(this, BazaarVoice);
  this.onReady = function (callback) {
    if (_this.isReady) {
      return callback();
    }
    window.bvCallback = function (BV) {
      BV.api.ready().then(function () {
        callback();
        _this.isReady = true;
      })["catch"](function (error) {
        console.error('BV api loading error', error);
      });
    };
    return null;
  };
  this.trackCatalogUpdate = function (products, lang) {
    window.bvDCC = {
      catalogData: {
        locale: lang,
        catalogProducts: products
      }
    };
    products.forEach(function (product) {
      window.BV.pixel.trackEvent('CatalogUpdate', {
        type: 'Product',
        locale: lang,
        catalogProducts: [product]
      });
    });
  };
  this.trackConversion = function (_ref) {
    var type = _ref.type,
      label = _ref.label,
      value = _ref.value;
    window.BV.pixel.trackConversion({
      type: type,
      label: label,
      value: value
    });
  };
  this.isReady = false;
});
var bazaarvoice = new BazaarVoice();
var cachedScripts = [];
var useScript = function useScript(src) {
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    loaded = _useState2[0],
    setLoaded = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    error = _useState4[0],
    setError = _useState4[1];
  var handleLoad = function handleLoad() {
    setLoaded(true);
    setError(false);
  };
  var handleError = function handleError() {
    setLoaded(false);
    setError(true);
  };
  var addScriptWithListeners = useCallback(function () {
    cachedScripts.push(src);
    var script = document.createElement('script');
    script.src = src;
    script.async = true;
    script.addEventListener('load', handleLoad);
    script.addEventListener('error', handleError);
    document.body.appendChild(script);
    return function () {
      script.removeEventListener('load', handleLoad);
      script.removeEventListener('error', handleError);
    };
  }, [src]);
  useEffect(function () {
    if (cachedScripts.includes(src)) {
      handleLoad();
      return;
    }
    addScriptWithListeners();
  }, [addScriptWithListeners, src]);
  return [loaded, error];
};
var useBazaarVoice = function useBazaarVoice(url) {
  useScript(url);
  var trackCatalogUpdate = useCallback(function (products, lang) {
    bazaarvoice.onReady(function () {
      bazaarvoice.trackCatalogUpdate(products, lang);
    });
  }, []);
  var trackConversion = useCallback(function (_ref2) {
    var type = _ref2.type,
      label = _ref2.label,
      value = _ref2.value;
    bazaarvoice.onReady(function () {
      bazaarvoice.trackConversion({
        type: type,
        label: label,
        value: value
      });
    });
  }, []);
  return {
    trackCatalogUpdate: trackCatalogUpdate,
    trackConversion: trackConversion
  };
};
export { useBazaarVoice };